module.exports = __webpack_public_path__ + "static/img/cloud2.5b0bc86e.svg";